var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import { makeStyles, Button, CircularProgress } from '@material-ui/core';
import GetApp from '@material-ui/icons/GetApp';
import { userArrayToBlob } from './utils';
var useStyles = makeStyles(function () { return ({
    root: {
        color: '#646464'
    },
    progress: {
        color: '#646464',
        marginLeft: '8px'
    }
}); });
function UsersDownloadLink(_a) {
    var users = _a.users;
    var classes = useStyles();
    var _b = __read(React.useState(), 2), csv = _b[0], setCsv = _b[1];
    var _c = __read(React.useState(false), 2), doGenerate = _c[0], setDoGenerate = _c[1];
    var _d = __read(React.useState(false), 2), isLoading = _d[0], setIsLoading = _d[1];
    // FIXME:
    // There are details here that are unknown at this time...
    // So setting up for async, but this is actually synchronous
    React.useEffect(function () {
        if (doGenerate) {
            var csv_1 = userArrayToBlob(users);
            setCsv(csv_1);
            setIsLoading(false);
            setDoGenerate(false);
            var url = window.URL.createObjectURL(csv_1);
            var downloadLink = document.createElement('a');
            downloadLink.href = url;
            downloadLink.download = 'users.csv';
            // Could be turned off by user
            downloadLink.click();
            window.URL.revokeObjectURL(url);
            downloadLink.remove();
        }
    }, [doGenerate, users]);
    var handleDownloadClick = function () {
        setIsLoading(true);
        setDoGenerate(true);
    };
    return (React.createElement(Button, { "data-testid": "lcui-download-users-button", onClick: handleDownloadClick, className: classes.root, endIcon: !isLoading && React.createElement(GetApp, null) },
        "Download CSV",
        isLoading ? React.createElement(CircularProgress, { size: 20, className: classes.progress }) : null));
}
export default UsersDownloadLink;
//# sourceMappingURL=UsersDownloadLink.js.map